import { memo } from 'react'
import { useDispatch } from 'react-redux'

import Button from '../button/Button'
import { KYC_PROFILE_DISPATCH } from '../../../store/reducers/account/kyc'
import { changeKYCState } from '../../../store/actions/kyc'
import { DEFAULT_CONTAINER_STATE } from '../../../constants/containerStates'

const PurchaseStatusButton = ({ t, ...restProps }) => {
  const dispatch = useDispatch()
  const handlePurchaseStatus = () => {
    dispatch(
      changeKYCState(KYC_PROFILE_DISPATCH.POPUP_STATE, {
        id: DEFAULT_CONTAINER_STATE.PURCHASE_STATUS
      })
    )
  }
  return (
    <Button
      label={t('membership.purchase-status')}
      onClick={handlePurchaseStatus}
      {...restProps}
    />
  )
}

export default memo(PurchaseStatusButton)
